import { render } from "./SuccessStoriesPage.vue?vue&type=template&id=b0daa354&scoped=true"
import script from "./SuccessStoriesPage.vue?vue&type=script&lang=js"
export * from "./SuccessStoriesPage.vue?vue&type=script&lang=js"

import "./SuccessStoriesPage.vue?vue&type=style&index=0&id=b0daa354&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0daa354"]])

export default __exports__